const assignProductOption = (product, key, value) => {
  product.product_option = product.product_option || {}
  product.product_option.extension_attributes = product.product_option.extension_attributes || {}

  product.product_option.extension_attributes[key] = value
}

export default assignProductOption
